// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__UfjH3","icon":"Header_icon__8eJ17","span":"Header_span__jF49l"};